var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 flex-col justify-end home-container"},[(_vm.isFullPageView)?_c('conversation-list-wrap'):_vm._e(),_c('team-availability',{attrs:{"available-agents":_vm.availableAgents,"has-conversation":!!_vm.conversationSize},on:{"start-conversation":_vm.startConversation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }